import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep-repair',
    templateUrl: './keep-repair.component.html',
    styleUrls: ['./keep-repair.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepRepairComponent {

}
